export const initAboutPageLanguage = () => {
  const toggleElement = document.getElementById('banner-toggle');
  if (!toggleElement) return;

  const toggleBtn = document.getElementById('btn-toggle');
  const englishTitle = document.getElementById('about-banner-english');
  const teReoTitle = document.getElementById('about-banner-te-reo');
  const teReoBtn = document.getElementById('mri');
  const engBtn = document.getElementById('eng');
  let selected = 'Te Reo';

  toggleElement.addEventListener('click', () => {
    selected = selected === 'Te Reo' ? 'English' : 'Te Reo';
    toggleBtn.classList.toggle('transformed');

    // Toggle hidden class
    englishTitle.classList.toggle('about-banner__title--hidden');
    teReoTitle.classList.toggle('about-banner__title--hidden');

    // Toggle active class
    teReoBtn.classList.toggle('lang--active');
    engBtn.classList.toggle('lang--active');

    toggleElement.setAttribute('aria-label', `${selected} selected`);
  });

  toggleElement.addEventListener('mousedown', () => { toggleBtn.classList.add('mousedown'); });
  toggleElement.addEventListener('mouseup', () => { toggleBtn.classList.remove('mousedown'); });
};

export default 'initAboutPageLanguage';
